<template>
  <component
    :is="tag"
    :class="[
      '[&_h2]:text-2xl md:[&_h2]:text-4xl [&_h3]:text-xl [&_h4]:text-xl md:[&_h3]:text-2xl',
      '[&_h2,&_h3,&_h4]:mb-5 [&_*+h2,&_*+h3,&_*+h4]:mt-7.5 [&_h2,&_h3,&_h4]:font-semibold',
      '[&_p]:not-first-of-type:pt-2 [&_a]:underline',
      '[&_ul,&_ol]:flex [&_ul,&_ol]:flex-col [&_ul,&_ol]:gap-2 [&_ul,&_ol]:mt-2',
      '[&_ul>li,&_ol>li]:pl-5.5 [&_ul>li,&_ol>li]:relative',
      '[&_ul>li]:before:content-[\'\'] counter-reset [&_ul>li]:before:block',
      '[&_ul>li]:before:rounded-full [&_ul>li]:before:w-2',
      '[&_ul>li,&_ol>li]:before:absolute [&_ul>li,&_ol>li]:before:top-[0.5rem]',
      '[&_ul>li,&_ol>li]:before:left-0 [&_ol>li]:before:-translate-y-[0.5rem]',
      '[&_ul>li]:before:h-2 [&_ol>li]:before:font-semibold',
      section_bg === '(--main-color)'
        ? '[&_ul>li]:before:bg-(--accent-color) [&_ol>li]:before:text-(--accent-color) [&_a]:text-(--accent-color) [&_a]:hover:text-(--white)'
        : '[&_ul>li]:before:bg-(--main-color) [&_ol>li]:before:text-(--main-color) [&_a]:text-(--main-color) [&_a]:hover:text-(--accent-color)',
    ]"
  />
</template>

<script lang="ts">
import DOMPurify from "dompurify";

export default {
  name: "RawHtml",
  props: {
    html: {
      type: String,
      required: true,
    },
    tag: {
      type: String,
      default: "div",
    },
    section_bg: {
      type: String,
      default: "",
    },
  },
  watch: {
    html: {
      immediate: true,
      handler: "renderHTML",
    },
  },
  methods: {
    renderHTML() {
      this.$nextTick(() => {
        this.$el.innerHTML = "";

        if (!this.html) return;
        this.$el.insertAdjacentHTML("beforeend", DOMPurify.sanitize(this.html));

        this.$el.querySelectorAll('a[href^="http"]').forEach((externalLink: HTMLAnchorElement) => {
          externalLink.target = "_blank";
          externalLink.rel = "noopener";
        });
      });
    },
  },
};
</script>
